import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (history.action === 'POP') {
      return;
    }
    if (location.state && location.state.preserveScroll) {
      return;
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}